var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDownloadFileIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 50,
    height: 43,
    viewBox: "0 0 50 43",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "downloadFileIcon"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    stroke: "#707070",
    d: "M694.079 359.027h50v43h-50z",
    "data-name": "Rectangle 3754"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#downloadFileIcon)",
    "data-name": "Mask Group 251",
    transform: "translate(-694.079 -359.027)"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 10298"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#f9ba48",
    d: "m717.016 370.716 1.375 20.628h-4.125l8.251 9.626 8.251-9.626h-4.126l1.375-20.628Z",
    "data-name": "Path 2826"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#333",
    d: "M733.518 365.215v-6.188h-35.754v31.629a4.13 4.13 0 0 0 4.125 4.126h14.418l6.21 7.245 6.21-7.245h7.542a4.13 4.13 0 0 0 4.126-4.126v-25.441Zm-34.379 25.441v-30.254h33v4.813h-15.386l-1.374-2.75h-10.74v28.191a2.75 2.75 0 1 1-5.5 0Zm39.881 0a2.753 2.753 0 0 1-2.75 2.75h-6.364l2.358-2.75h-4.885l1.326-19.895-1.372-.091-1.426 21.357h3.366l-6.756 7.882-6.756-7.882h3.366l-1.425-21.356-1.372.091 1.326 19.894h-4.885l2.358 2.75h-10.173a4.1 4.1 0 0 0 1.059-2.75V363.84h8.514l1.375 2.75h23.115v24.066Z",
    "data-name": "Path 2827"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownloadFileIcon);
export default __webpack_public_path__ + "static/media/downloadFileIcon.4be20ac6756f2fc9555e0a5c8bb04b66.svg";
export { ForwardRef as ReactComponent };